/**
 * MetricCard — Dashboard metric card with glassmorphism styling.
 */

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
}

export function MetricCard({ title, value, subtitle, icon, trend }: MetricCardProps) {
  const trendColors = {
    up: 'text-green-700',
    down: 'text-red-700',
    neutral: 'text-slate-muted',
  };

  return (
    <div className="glass-card flex flex-col gap-3 hover:scale-[1.02] transition-transform">
      <div className="flex items-center justify-between">
        <span className="text-[16px] font-semibold text-slate-muted uppercase tracking-wide">
          {title}
        </span>
        {icon && <span className="text-primary-teal">{icon}</span>}
      </div>
      <p className="text-heading-lg font-bold text-slate-text">{value}</p>
      {subtitle && (
        <p className={`text-[16px] font-medium ${trend ? trendColors[trend] : 'text-slate-muted'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
